import React from 'react';
import './loading.scss';

export const Loading = () => {
  const customWidgetStyles = {
    '--page-background-color': window?.tz_globalConfigs?.styling?.pageBackgroundColor || '#fff',
    '--widget-background-color': window?.tz_globalConfigs?.styling?.widgetBackgroundColor || '#fc3',
  }  as React.CSSProperties;

  return (
    <div className="loading" style={customWidgetStyles}>
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
